import '@material/list/dist/mdc.list.css';
import { List as L, ListItem as LI } from '@rmwc/list';

export const List = L;
export const ListItem = LI;
